const layout = () =>
    import('@/views/layout.vue')
const Login = () =>
    import('@/views/Login.vue')
const Home = () =>
    import('@/views/Home.vue')
const Search = () =>
    import('@/views/Search/Index.vue')
// const BusinessIndex = () => import('@/views/Business/Index.vue')
// const BusinessResult = () => import('@/views/Business/BusinessResult.vue')
// const BusinessSearch = () => import('@/views/Business/BusinessSearch.vue')
const BusinessDetail = () => import('@/views/Business/BusinessDetail.vue')
const Intelligence = () => import('@/views/intelligence/index.vue')
const SearchHome = () =>
    import('@/views/Search/Search.vue')
const CompanyResult = () =>
    import('@/views/Company/Result.vue')
const CompanyDetail = () =>
    import('@/views/Company/Detail.vue')
const TradeResult = () =>
    import('@/views/Trade/TradeResult.vue')
const TradeResults = () =>
    import('@/views/Trade/TradeResults.vue')
const TradeDetail = () =>
    import('@/views/Trade/Detail.vue')
const SearchSenior = () =>
    import('@/views/Search/Senior.vue')
const Dashboard = () =>
    import('@/views/Dashboard.vue')
const Product = () =>
    import('@/views/Product/Product.vue')
const ProductDetail = () =>
    import('@/views/Product/Detail.vue')
const Trend = () =>
    import('@/views/Trend/Index.vue')
const TrendIndustry = () =>
    import('@/views/Trend/Industry.vue')
const TrendMarket = () =>
    import('@/views/Trend/Market.vue')
    const TrendMarketTrend = () =>
    import('@/views/Trend/marketTrend.vue')
const China = () =>
    import('@/views/Trend/China.vue')
const User = () =>
    import('@/views/User.vue')
const Homes = () =>
    import('@/views/Homes.vue')
const Message = () =>
    import('@/views/Message.vue')
const ProductReport = () =>
    import('@/views/Report/productReport.vue')
const productBusiness = () =>
    import('@/views/Report/productBusiness.vue')
const biAnalysisReport = () =>
    import('@/views/Report/biAnalysisReport.vue')
const TrendIndustryReport = () =>
    import('@/views/Report/productReportcompre.vue')
const productChina = () =>
    import('@/views/Report/productChina.vue')
const businessDetailReport = () => import('@/views/Report/businessDetailReport.vue')
const NotFindPage = () =>
    import('@/views/404.vue')
const errorPage = () =>
    import('@/views/error.vue')
const Analysis = () =>
    import ('@/views/analysis/index.vue')
const AnalysisDetail = () =>
    import ('@/views/analysis/detail.vue')
const BiAnalysis = () =>
    import('@/views/BiAnalysis/index.vue')
const CantonFair = () =>
    import('@/views/CantonFair/index.vue')
const BindWechat = () => import ('@/views/bindWechat/BindWechat.vue')
const creditReport = () => import ('@/views/Report/creditReport.vue')
const creditReportCn = () => import ('@/views/Report/creditReportCn.vue')
const Credit = () => import ('@/views/Credit/index.vue')
const CreditResult = () => import ('@/views/Credit/result.vue')
const FocusOnCollectionDetail =()=>import('@/views/Dashboard/dashboardSecondaryPage/focusOnCollectionDetail.vue')
const DownloadCenter =()=>import('@/views/Dashboard/dashboardSecondaryPage/DownloadCenter.vue')
const AIGPT =()=>import('@/views/AIGPT/index.vue')
const smartBusiness =()=>import('@/views/smartBusiness/index.vue')
const chromeLogin =()=>import('@/views/chromeLogin.vue')
import i18 from '@/utils/I18.js'
let menus = []
let dynamicData = JSON.parse(localStorage.getItem('gt6_dynamic'))
if (dynamicData && dynamicData.lang == localStorage.getItem("language")) {
    menus = dynamicData.menus
} else {
    window.addEventListener('setItemEvent', (e) => {
        if ((e.key) == 'gt6_dynamic') {
            let data = JSON.parse(e.newValue)
            menus = data.menus
        }
    })
}
const routes = [{
    path: '/',
    redirect: '/home',
    hidden: true
},
{
    path: '/login',
    name: 'Login',
    meta: {
        requireAuth: false,
        name: i18.language('登录')
    },
    component: Login,
    hidden: true
},
{
    path: '/chromeLogin',
    name: 'chromeLogin',
    meta: {
        requireAuth: false,
        name: i18.language('登录')
    },
    component: chromeLogin,
    hidden: true
},
{
    path: '/Message',
    name: 'Message',
    meta: {
        name: 'message'
    },
    component: Message,
    hidden: true
},
{
    path: '/home',
    name: 'Home',
    meta: {
        requireAuth: true,
        name: i18.language('首页'),
        title: `${i18.language('首页')}`
    },
    component: Home,
    hidden: true
},
{
    path: '/dashboard',
    namet: 'overview',
    component: layout,
    // name: 'Dashboard',
    meta: {
        requireAuth: true,
        // name:'header.navBar.overView',
        name: `${i18.language("总览")}`,
        title: `${i18.language("总览")}`
    },
    // component: Dashboard,
    children: [{
        path: '',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
            title: `${i18.language("总览")}`
        },
    },
    {
        path: 'focusOnCollectionDetail',
        meta: {
            requireAuth: true,
            name: i18.language("关注与收藏"),
            title: `${i18.language("关注与收藏")}`
        },
        name: 'FocusOnCollectionDetail',
        component: FocusOnCollectionDetail
    },{
        path: 'downloadCenter',
        meta: {
            requireAuth: true,
            name: i18.language("下载中心"),
            title: `${i18.language("下载中心")}`
        },
        name: 'downloadCenter',
        component: DownloadCenter
    }
]
},
{
    path: '/intelligence',
    namet: 'intelligence',
    name: 'Intelligence',
    meta: {
        requireAuth: true,
        name: `${i18.language("总览")}`,
        title: `${i18.language("总览")}`
    },
    component: Intelligence,
    hidden: true
},
{
    path: '/company',
    namet: 'topeasess',
    component: Search,
    meta: {
        requireAuth: true,
        // name: 'header.navBar.teeSou',
        name: `${i18.language("特易搜搜")}`,
        title: `${i18.language("特易搜搜")}`
    },
    children: [{
        path: '',
        meta: {
            title: `${i18.language("特易搜搜")}`,
            name: `${i18.language("特易搜搜")}`
        },
        name: 'SearchCompany',
        component: SearchHome
    },
    {
        path: 'result',
        meta: {
            requireAuth: true,
            name: i18.language('搜索公司'),
            title: `${i18.language("特易搜搜")}`
        },
        name: 'CompanyResult',
        component: CompanyResult
    },
    {
        path: 'smartBusiness',
        meta: {
            requireAuth: true,
            name: i18.language('智能商机'),
            title: `${i18.language("智能商机")}`
        },
        name: 'smartBusiness',
        component: smartBusiness
    },
    {
        path: 'detail/:id/:isMerge',
        meta: {
            requireAuth: true,
            name: i18.language('搜索公司'),
            title: `${i18.language("特易搜搜")}`
        },
        name: 'CompanyDetail',
        component: CompanyDetail
    },
    {
        path: 'busdetail/:id/:merage',
        meta: {
            requireAuth: true,
            name: i18.language('搜索公司'),
            title: `${i18.language("特易搜搜")}`
        },
        name: 'BusinessDetail',
        component: BusinessDetail
    },
    {
        path: 'cantonFair',
        meta: {
            requireAuth: true,
            name: i18.language('广交会'),
            title: `${i18.language("特易搜搜")}`
        },
        name: 'CantonFair',
        component: CantonFair
    },
    {
        path: 'credit',
        meta: {
            requireAuth: true,
            name: i18.language('信用报告'),
            title: `${i18.language("特易搜搜")}`
        },
        name: 'Credit',
        component: Credit
    },
    {
        path: 'credit/result',
        meta: {
            requireAuth: true,
            name: i18.language('信用报告'),
            title: `${i18.language("特易搜搜")}`
        },
        name: 'CreditResult',
        component: CreditResult
    },
    {
        path: 'senior',
        meta: {
            requireAuth: true,
            name: i18.language('高级搜索'),
            title: `${i18.language("特易搜搜")}`
        },
        name: 'CompanySenior',
        component: SearchSenior
    }
    ]
},
// {
//     path: '/business',
//     namet: 'business_data',
//     component: BusinessSearch,
//     meta: {
//         requireAuth: true,
//         name: menus[2],
//         // name: 'header.navBar.businessData',
//         title: `${i18.language("商业数据")}`
//     },
//     children: [
//         {
//             path: '',
//             meta: {
//                 requireAuth: true,
//                 name: i18.language('搜索数据'),
//                 title: `${i18.language("商业数据")}`
//             },
//             name: 'BusinessIndex',
//             component: BusinessIndex
//         },
//         {
//             path: 'result',
//             meta: {
//                 requireAuth: true,
//                 name: i18.language('搜索数据'),
//                 title: `${i18.language("商业数据")}`
//             },
//             name: 'BusinessResult',
//             component: BusinessResult
//         },
//     ]
// },
{
    path: '/trade',
    namet: 'trade',
    component: Search,
    meta: {
        requireAuth: true,
        name: 'header.navBar.tradeIntelligence',
        // title: `${i18.language("贸易情报")}`
    },
    children: [{
        path: '',
        meta: {
            title: `${i18.language("贸易情报")}`,
            name: 'header.navBar.tradeIntelligence',
        },
        name: 'SearchTrade',
        component: SearchHome
    },
    // {
    //     path: 'result',
    //     meta: {
    //         requireAuth: true,
    //         name: i18.language("贸易情报"),
    //         title: `${i18.language("贸易情报")}`
    //     },
    //     name: 'TradeResult',
    //     component: TradeResult
    // },
    // 6.0贸易结果页面
    {
        path: 'result',
        meta: {
            requireAuth: true,
            name: i18.language("贸易情报"),
            title: `${i18.language("贸易情报")}`
        },
        name: 'TradeResults',
        component: TradeResults
    },
    {
        path: 'detail/:id',
        meta: {
            requireAuth: true,
            name: i18.language("贸易情报"),
            title: `${i18.language("贸易情报")}`
        },
        name: 'TradeDetail',
        component: TradeDetail
    },
    {
        path: 'senior',
        meta: {
            requireAuth: true,
            name: i18.language("高级搜索"),
            title: `${i18.language("贸易情报")}`
        },
        name: 'TradeSenior',
        component: SearchSenior
    }
    ]
},
{
    path: '/product',
    component: layout,
    namet: 'product_analysis',
    meta: {
        requireAuth: true,
        // name: 'header.navBar.productAnalysis',
        name: `${i18.language("BI深度分析")}`,
        title: `${i18.language("BI深度分析")}`
    },
    children: [{
        path: '',
        meta: {
            requireAuth: true,
            name: i18.language("BI深度分析"),
            title: `${i18.language("BI深度分析")}`
        },
        name: 'Product',
        component: Product
    },
    {
        path: 'detail/:id',
        meta: {
            requireAuth: true,
            name: i18.language("BI深度分析"),
            title: `${i18.language("BI深度分析")}`
        },
        name: 'ProductDetail',
        component: ProductDetail
    },
    {
        path: 'biAnalysis',
        component: BiAnalysis,
        meta: {
            title: `${i18.language("BI深度分析")}`
            // id: 5
        },
        name: 'BiAnalysis',
        // hidden: true
    },
        // {
        //   path: 'productReport',
        //   meta: {
        //     requireAuth: true,
        //     name: '产品分析',
        //     title: `产品分析`
        //   },
        //   name: 'productReport',
        //   component: ProductReport
        // }
    ]
},
{
    path: '/trend',
    component: layout,
    namet: 'trend_analysis',
    meta: {
        requireAuth: true,
        name: 'header.navBar.trendAnalysis',
        // name: `${i18.language("趋势分析")}`,
        title: `${i18.language("趋势分析")}`
    },
    children: [{
        path: '',
        name: 'Trend',
        component: Trend,
        meta: {
            title: `${i18.language("趋势分析")}`,
            name: `${i18.language("趋势分析")}`,
        },
    },
    {
        path: 'industry/:id',
        meta: {
            requireAuth: true,
            name: i18.language("趋势市场分析"),
            title: `${i18.language("趋势分析")}`
        },
        name: 'TrendIndustry',
        component: TrendIndustry
    },
    {
        path: 'market/:id',
        meta: {
            requireAuth: true,
            name: i18.language("趋势市场分析"),
            title: `${i18.language("趋势分析")}`
        },
        name: 'TrendMarket',
        component: TrendMarket
    }, 
    {
        path: 'marketTrend',
        meta: {
            requireAuth: true,
            name: i18.language("趋势市场分析"),
            title: `${i18.language("趋势分析")}`
        },
        name: 'TrendMarketTrend',
        component: TrendMarketTrend
    }, 
    {
        path: 'china/:id',
        meta: {
            requireAuth: true,
            name: i18.language('趋势出口行业纬度'),
            title: `${i18.language("趋势分析")}`
        },
        name: 'China',
        component: China
    }

    ]
},
{
    path: '/analysis',
    component: layout,
    namet: 'marketing_research',
    meta: {
        requireAuth: true,
        name: 'header.navBar.analysisReport',
        // name: `${i18.language("市场研究")}`,
        title: `${i18.language("市场研究")}`
    },
    children: [{
            path: '',
            name: 'Analysis',
            component: Analysis,
            meta:{
                title: `${i18.language("市场研究")}`,
                name: `${i18.language("市场研究")}`,
            }
        },{
            path: 'detail',
            meta: {
                title: `${i18.language("市场研究")}`
            },
            name: 'AnalysisDetail',
            component: AnalysisDetail
        }
    ]
},
{
    path: '/user',
    component: User,
    meta: {
        requireAuth: true,
        name: i18.language("账户中心"),
        title: i18.language("账户中心"),
        id: 5
    },
    hidden: true
},
{
    path: '/homes',
    component: Homes,
    meta: {
        requireAuth: true,
        name: 'Homes',
    },
    hidden: true
},
{
    path: '/report',
    name: 'Report',
    hidden: true,
    // meta: {
    //   requireAuth: true,
    //   name: '报告'
    // },
    component: layout,
    children: [{
        path: 'productReport',
        component: ProductReport,
        name: '报告-产品分析报告',
        title: '产品分析（报告）'
    },
    {
        path: 'productBusiness',
        component: productBusiness,
        name: '报告-公司详情报告'
    },
    {
        path: 'biAnalysisReport',
        component: biAnalysisReport,
        name: '报告-数据分析报告'
    },
    {
      path: 'businessDetailReport',
      component: businessDetailReport,
      name: '商业数据-公司详情报告'
    },
    {
        path: 'trendIndustryReport',
        component: TrendIndustryReport,
        name: '报告-趋势分析报告(行业维度)'
    },
    {
        path: 'productChina',
        component: productChina,
        name: '报告-趋势分析报告(中国专属)'
    },
    {
        path: 'creditReport',
        component: creditReport,
        name: '报告-信用报告'
    },
    {
        path: 'creditReportCn',
        component: creditReportCn,
        name: '报告-信用报告(China)'
    },
    {
        path: 'bindWechat',
        name: 'bindWechat',
        meta: {
          name: 'bindWechat'
        },
        component: BindWechat,
        hidden: true
    },
    ]
},
{
    path: "/AIGPT",
    component: layout,
    hidden: true,
    children: [{
        path: '',
        component: AIGPT,
        name: 'AIGPT',
        title: 'AIGPT'
    }]
},
{
    path: '*',
    hidden: true,
    name: 'error',
    meta: {
        title: `404`
    },
    component: errorPage
}
    // {
    //   path: '*',
    //   hidden: true,
    //   meta: {
    //     title: `404`
    //   },
    //   component: NotFindPage
    // }
]

export default routes
